module.exports = __webpack_public_path__ + "static/img/joinBanner2.ad11eac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner2.jpg
// module id = fUkx
// module chunks = 0